import Header from "../Components/Header/Header";
import MainPage from "./Body/MainPage";
import '../../css/Page1.css';

function Page1() {
    return (
                <MainPage/>
    );
}
export default Page1;